<template>
    <v-select 
       :value="selected_causes" 
       v-bind:items="incidentcauses"
       item-value="code" 
       item-text="description" 
       :label="label"
       :clearable="isClearable"
       :multiple="isMultiple"
       @change="updateData">
        <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index >= 0 && index <= visibleChips">
                <span>{{ item.description }}</span>
            </v-chip>
            <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ selected_causes.length - visibleChips }})</span>
        </template>  
    </v-select>
</template>

<script>
export default {
    props: {
        selected_causes: {
            type: Array,
            default: function() { return []; },
        },
        label: {
            type: String,
            default: 'Caused by'
        },    
        field: {
            default: 'cause',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
        isMultiple:{
            type: Boolean,
            default: true
        },
        visibleChips:{
            type: Number,
            default: 4
        }         
    },  
    data() {
        return {
            incidentcauses: [],
        }
    },
    created() {
        this.getIncidentCauses();
    },
    methods: {
        getIncidentCauses() {
            this.$axios
                .post("ares/json/ares/huov/hokl/getKloz.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getKloz"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {                        
                        this.incidentcauses = res.data.getKloz;
                    }
                })
        },
        updateData(v){
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
        }
    }
}

</script>